import { createEvent, sample } from 'effector'
import { fx } from 'src/libs'
import {
  NotificationPayload,
  showNotification,
} from 'src/features/notifications'
import { $wallet } from 'src/pages/finSystem/wallets/details/model'

type ActionPayload = {
  idWallet: string
}
export const submitArchive = createEvent<ActionPayload>()
export const submitUnArchive = createEvent<ActionPayload>()

export const submitArchiveFx = fx<ActionPayload, ActionPayload>({
  method: 'PUT',
})

export const submitUnArchiveFx = fx<ActionPayload, ActionPayload>({
  method: 'PUT',
})

sample({
  clock: submitArchive,
  fn: ({ idWallet }) => ({ url: `/finance/wallet/archive/${idWallet}` }),
  target: submitArchiveFx,
})

sample({
  clock: submitUnArchive,
  fn: ({ idWallet }) => ({ url: `/finance/wallet/restore/${idWallet}` }),
  target: submitUnArchiveFx,
})

sample({
  clock: submitArchiveFx.done,
  source: $wallet,
  fn: (wallet) => ({ ...wallet, archivedAt: String(Date.now()) }),
  target: $wallet,
})

sample({
  clock: submitUnArchiveFx.done,
  source: $wallet,
  fn: (wallet) => ({ ...wallet, archivedAt: null }),
  target: $wallet,
})

sample({
  clock: [submitUnArchiveFx.failData, submitArchiveFx.failData],
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Request failed',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})

sample({
  clock: submitArchiveFx.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Request success',
    description: 'Wallet archived successfully',
  }),
  target: showNotification,
})

sample({
  clock: submitUnArchiveFx.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Request success',
    description: 'Wallet restored successfully',
  }),
  target: showNotification,
})
